import {Component, effect, inject, OnDestroy} from '@angular/core';
import {watchParentParam} from "@utils";
import {UserStateService} from "../../user-service";
import {OptionType, ToggleComponent} from "../../../../../components/forms/toggle/toggle.component";
import {DatePipe} from "@angular/common";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {UserService} from "@api-services";
import {switchMap, takeUntil} from "rxjs/operators";
import {Subject} from "rxjs";
import {InputComponent} from "@components";
import {CreateUserRequestDto} from "@api-contracts";
import StatusEnum = CreateUserRequestDto.StatusEnum;

@Component({
  selector: 'wun-contact',
  standalone: true,
  imports: [
    ToggleComponent,
    DatePipe,
    ReactiveFormsModule,
    InputComponent
  ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss'
})
export class ContactComponent implements OnDestroy {
  id = watchParentParam('id', 2, d => Number(d));
  public readonly userStateService = inject(UserStateService);
  private readonly userService = inject(UserService);

  blogOptions: OptionType[] = [
    {
      label: 'Abilitato',
      value: true,
    },
    {
      label: 'Disabilitato',
      value: false,
    }
  ];
  form = new FormGroup({
    firstName: new FormControl("", Validators.required),
    lastName: new FormControl("", Validators.required),
    // birthday: new FormControl("", Validators.required),
    phone: new FormControl("", Validators.required),
    email: new FormControl("", Validators.required),
    country: new FormControl("", Validators.required),
    status: new FormControl<StatusEnum>('ACTIVE', Validators.required),
    city: new FormControl("", Validators.required),
    blogAuthorEnabled: new FormControl(false, Validators.required),
    assignedToGallery: new FormControl(""),
  })
  destroy$ = new Subject<void>();

  constructor() {
    this.userStateService.navbarButtonState.set('IDLE')
    effect(() => {
      const _ = this.userStateService.currentUser();
      if (_)
        this.form.setValue({
          blogAuthorEnabled: _.blogAuthorEnabled || false,
          // birthday: _.birthday,
          status: _.status,
          country: _.country,
          email: _.email,
          firstName: _.firstName,
          lastName: _.lastName,
          phone: _.phone,
          city: _.city,
          assignedToGallery: _.assignedToGallery || ''
        })
    });

    this.userStateService.navbarButtonClickedSubject.subscribe(
      d => {
        if (this.userStateService.navbarButtonState() === 'IDLE')
          this.userStateService.navbarButtonState.set('EDIT')
      }
    )

    this.userStateService
      .navbarButtonClickedSubject
      .pipe(
        takeUntil(this.destroy$),
        switchMap(() => this.updateUser())
      )
      .subscribe(
        d => {
          this.userStateService.navbarButtonState.set('IDLE')
          const _ = this.form.value;
          this.userStateService.currentUser.update(d => {
            if (d)
              return {
                ...d,
                blogAuthorEnabled: _.blogAuthorEnabled || false,
                // birthday: _.birthday!,
                status: _.status! as StatusEnum,
                country: _.country!,
                email: _.email!,
                firstName: _.firstName!,
                lastName: _.lastName!,
                phone: _.phone!,
                city: _.city!,
                assignedToGallery: _.assignedToGallery || ''
              }
            return d;
          })
        }
      )
  }

  updateUser() {
    const formValue = this.form.value;
    const _ = this.userStateService.currentUser();
    return this.userService.usersUpdate({
      id: this.id()!,
      patchUserRequestDto: {
        // birthday: formValue.birthday!,
        blogAuthorEnabled: formValue.blogAuthorEnabled!,
        country: formValue.country!,
        email: formValue.email!,
        firstName: formValue.firstName!,
        lastName: formValue.lastName!,
        phone: formValue.phone!,
        status: formValue.status!,
        businessName: _?.businessName || '-',
        vatNumber: _?.vatNumber || '-',
        assignedToGallery: formValue.assignedToGallery || null,
      }
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
    this.userStateService.navbarButtonState.set('HIDDEN');
  }

}
